module.exports = __webpack_public_path__ + "img/company-icon.5dcb860b.png";